export default __webpack_public_path__ + "static/media/addpasta.6d3bd772.svg";